import { useEffect, useState } from 'react';

export function useOverflowTest(ref: React.RefObject<HTMLElement | null>) {
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    if (!ref?.current) return;

    setIsOverflowing(ref.current.scrollWidth > ref.current.clientWidth);
  }, [ref]);

  return isOverflowing;
}
